// removed by extract-text-webpack-plugin
module.exports = {"description":"description_2410L","actions":"actions_L4Hz9","back":"back_2cAiu","passwordInput":"passwordInput_15Vfs","passwordReset":"passwordReset_3tGJB"};


//////////////////
// WEBPACK FOOTER
// ./app/components/login/styles.scss
// module id = 443
// module chunks = 1